import React, { useState, useEffect } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "../../screens/Landing/components/Carousel/Carousel.scss";

interface ISlide {
  title: string;
  content: string;
  content2?: string;
  image: string;
}

interface IProps {
  slides: ISlide[];
  textFirst?: boolean;
}

export const CarouselShared: React.FC<IProps> = ({ slides, textFirst = true }) => {
  const [index, setIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setIndex((prev) => (prev - 1 + slides.length) % slides.length);
  };

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(nextSlide, 7000);
    return () => clearInterval(interval);
  }, [slides.length, isPaused]);

  if (!slides || slides.length === 0) return null;
  const currentSlide = slides[index];

  return (
    <div
      className="modern-abece-carousel"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div className="carousel-card-container">
        <div className="row align-items-center g-4">
          {/* Columna de Texto e Información */}
          <div className="col-12 col-lg-7 order-2 order-lg-1">
            <div className="carousel-content-wrapper">
              <div className="carousel-meta-header">
                <span className="step-badge">
                  <span className="step-dot" />
                  Pregunta {index + 1} de {slides.length}
                </span>
                <span className="abece-tag">Guía Oficial de Convocatorias</span>
              </div>

              <h3 className="carousel-question-title">{currentSlide.title}</h3>

              <div className="carousel-answer-body">
                <p className="answer-text">{currentSlide.content}</p>
                {currentSlide.content2 && (
                  <p className="answer-text-secondary">{currentSlide.content2}</p>
                )}
              </div>

              {/* Controles de navegación y puntos */}
              <div className="carousel-controls-dock">
                <div className="carousel-arrow-buttons">
                  <button
                    type="button"
                    className="carousel-nav-btn"
                    onClick={prevSlide}
                    aria-label="Paso anterior"
                    title="Paso anterior"
                  >
                    <LeftOutlined />
                  </button>
                  <button
                    type="button"
                    className="carousel-nav-btn"
                    onClick={nextSlide}
                    aria-label="Paso siguiente"
                    title="Paso siguiente"
                  >
                    <RightOutlined />
                  </button>
                </div>

                <div className="carousel-dots-strip">
                  {slides.map((_, i) => (
                    <button
                      key={i}
                      type="button"
                      className={`carousel-dot-pill ${i === index ? "active" : ""}`}
                      onClick={() => setIndex(i)}
                      aria-label={`Ir al paso ${i + 1}`}
                      title={`Paso ${i + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Columna de Imagen */}
          <div className="col-12 col-lg-5 order-1 order-lg-2 text-center">
            <div className="carousel-image-frame">
              <img
                src={currentSlide.image}
                alt={currentSlide.title}
                className="carousel-illustration-img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
